import { init, track, identify, Identify } from '@amplitude/analytics-browser'
import { idIncrement } from 'services/helpers/idIncrement'

const API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY

const initTracker = (userId) => init(API_KEY, idIncrement(userId))

export { initTracker, track, identify, Identify }
